import React, { useEffect, useState } from 'react';
import { SparklesIcon } from '../lib/icons';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`fixed top-0 left-0 right-0 z-[60] transition-all duration-300 ${isScrolled ? 'bg-black/95 backdrop-blur-md shadow-lg py-3' : 'bg-transparent py-5'}`} data-id="element-128">
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-129">
        <div className="flex items-center gap-2" data-id="element-130">
          <SparklesIcon className="w-5 h-5 text-[#eab308]" data-id="element-131" />
          <span className="text-white font-bold text-lg md:text-xl tracking-wide" style={{
          fontFamily: "'Cormorant Garamond', serif"
        }} data-id="element-132">
            Academia Holística Argentina
          </span>
        </div>
      </div>
    </nav>;
}